import styled from 'styled-components/macro';
import { row_center_both, column, column_center_both } from 'src/App/Styles/styles-helpers';
import { GlobalColors, Rules } from 'src/App/Styles/Globals';

export const CommandItemContain = styled.div`
	${column}
	cursor: pointer;
	border-radius: ${Rules.radiusRoundContainer};
	flex: 1 1 130px;
	max-width: 400px;
	background: ${GlobalColors.black25};
	overflow: hidden;
	border: 1px solid transparent;
	transition: 0.2s;
	&:hover {
		border: 1px solid ${GlobalColors.pinkSamen};
	}
`;
export const CITopSection = styled.div`
	${column_center_both}
	flex: 1;
	padding: 10px;
`;
export const CIIllustrationContainer = styled.div`
	${row_center_both}
	margin-bottom: 10px;
`;
export const CIBottomBar = styled.div`
	${column}
	text-align: center;
	background: ${GlobalColors.black100};
	border-radius: ${Rules.radiusButtonCTA};
	min-height: 60px;
	margin: 10px;
	margin-top: 0;
`;
export const CIBitsNumberWrapper = styled.div`
	${row_center_both}
	background-color: ${GlobalColors.newPurple};
	border-radius: ${Rules.radiusButtonCTA};
	font-size: 0.75em;
	font-weight: 800;
	min-width: 50px;
	flex: 1;
	padding: 1em 0;
`;
export const CIBitsIconWrapper = styled.div`
	${row_center_both}
	padding: 10px 20px;
	height: 40px;
	img {
		height: 30px;
	}
`;
export const CIEmptyIcon = styled.div`
	width: 30px;
`;
export const CIFreeWrapper = styled.div`
	${row_center_both}
	padding: 5px;
`;
export const CITypeRow = styled.div`
	text-align: center;
	color: ${GlobalColors.newPrimary};
	font-size: 10px;
	font-weight: 600;
	margin-top: 0.2em;
`;
export const CIName = styled.div`
	flex: 1 1 auto;
	text-align: center;
	${row_center_both}
	font-size:12px;
	font-weight: 700;
`;
